import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import api from "../../../utils/api";
import axiosInstance from "../../../utils/axiosConfig";
import { RootState } from "../../rootReducer";

export const sendFileForSign = createAsyncThunk(
  "sendForSignHojaCargo",
  async (id: any, { rejectWithValue, getState }) => {
    try {
      const state = getState() as RootState;
      const { id: userAuthenticatedId } = state.userAuthentication?.user || {};

      const users = state.supervisorHome.userRoles;

      var rut = state.supervisorDocumentsList.datosHojaDeCargo[0]?.hojaCargo.personalRut;

      while (rut.charAt(0) === "0") {
        rut = rut.substring(1);
      }

      const stakeHolderId = users.filter((user) => user.user.dni == rut);

      //Obtener PDF de hoja de cargo

      const { data } = await axiosInstance.get(`${api.hojasDeCargoURL}hojacargo/getPdf?id=${id}`, {
        responseType: "arraybuffer",
      });

      //Convertir datos binarios a base 64

      //const base64 = await Buffer.from(data, "binary").toString("base64");

      const bytes = new Uint8Array(data);
      let binary = "";

      bytes.forEach((b) => (binary += String.fromCharCode(b)));

      const base64 = btoa(binary)

      //Convierte base64 a Blob

      const base64Response = await fetch(`data:application/pdf;base64,${base64}`);

      const blob = await base64Response.blob();

      //Crea form data para enviar tipo file
      const formData = new FormData();

      formData.append("file", blob, `Hc${id}.pdf`);

      //Carga del archivo
      const { data: dataResponse } = await axiosInstance.post(`${api.baseURL}archive`, formData);

      // Crea la HC para firma
      const { data: documentData } = await axiosInstance.post(`${api.baseURL}document`, {
        title: `Firma HC ${id}`,
        archive: dataResponse.id,
        author: userAuthenticatedId,
        category: "13",
        process: null,
        signatureProvider: "2",
        sourceOrganization: state.userAuthentication?.user?.sourceOrganization,
      });

      //Agrega firmantes
      await axiosInstance.post(`${api.baseURL}documentstakeholder`, {
        document: documentData.id,
        stakeholder: stakeHolderId[0]?.user.id,
        type: "Firmante",
        order: 1,
      });

      // Activa firma de hoja de cargo
      await axiosInstance.post(`${api.baseURL}document/activate`, {
        document: documentData.id,
        user: state.userAuthentication.user?.id,
      });

      //Actualizar el status de bd logistica

      await axiosInstance.put(`${api.hojasDeCargoURL}hojacargo/${id}`, {
        idDigitalSignature: documentData.id,
        statusDigitalSignature: "Pendiente Firma Digital",
      });

      return Response;
    } catch (error) {
      rejectWithValue(error);
    }
  }
);
